import React, {FC} from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {Checkbox} from '@optimaxdev/design-system';
import classNames from 'classnames';
import {useDispatch} from 'react-redux';

import {useFeature} from 'components/feature';
import {CHECKOUT_PAYMENT_STEP} from 'constants/analytics/events/checkout';
import {PRIVACY_POLICY, TERMS_AND_CONDITIONS} from 'constants/cmsContent';
import {openPopupWithCMSBlock} from 'desktop/reducers/cmsPopup';
import {AppThunkDispatchType} from 'desktop/store';
import {useGetCustomerData} from 'hooks/getCustomerData/getCustomerData';

import s from './paymentStepAgreement.scss';

type PropsType = {
    className?: string;
    isKlarna?: boolean;
};

/**
 * Component for order review "by placing this order you agree" line with or without checkbox
 */
export const PaymentStepAgreement: FC<PropsType> = ({className = '', isKlarna = false}) => {
    const isFacelift = useFeature('dCheckoutFacelift');

    const label = `By placing this order, you ${isFacelift && !isKlarna ? 'are agreeing' : 'agree'} to our`;

    const [isAgreementChecked, setAgreementChecked] = React.useState(false);
    const {strictPrivacy} = useGetCustomerData();
    const dispatch = useDispatch<AppThunkDispatchType>();

    const openTermsOfUse = () => {
        dispatch(
            openPopupWithCMSBlock({
                checkoutStep: 'PAYMENT_STEP',
                cmsBlockName: TERMS_AND_CONDITIONS,
            }),
        );
        sendDesktopAnalyticsEvent(CHECKOUT_PAYMENT_STEP, {
            message: 'Terms & Condition - opened',
            method: 'Payment',
        });
    };

    const openPrivacyPolicy = () => {
        dispatch(
            openPopupWithCMSBlock({checkoutStep: 'PAYMENT_STEP', cmsBlockName: PRIVACY_POLICY}),
        );
        sendDesktopAnalyticsEvent(CHECKOUT_PAYMENT_STEP, {
            message: 'Privacy Policy - opened',
            method: 'Payment',
        });
    };

    const handleCheck = () => {
        setAgreementChecked(value => !value);
    };

    return (
        <div
            className={classNames(
                s.termsCondition,
                {[s.termsConditionFacelift]: isFacelift},
                className,
            )}
        >
            {strictPrivacy ? (
                <Checkbox
                    isChecked={isAgreementChecked}
                    onChange={handleCheck}
                    size="small"
                    value={String(isAgreementChecked)}
                >
                    {label}
                </Checkbox>
            ) : (
                label
            )}
            <button className={s.link} onClick={openTermsOfUse} type="button">
                Terms of Use
            </button>
            and
            <button className={s.link} onClick={openPrivacyPolicy} type="button">
                Privacy Policy
            </button>
        </div>
    );
};
